var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 143,
    viewBox: "0 0 161 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69597 122.25L2.69603 122.25L69.0528 7.32474C70.1631 5.40176 71.76 3.80492 73.683 2.6947C75.606 1.58448 77.7873 1 80.0078 1C82.2283 1 84.4097 1.58448 86.3327 2.6947C88.2557 3.80492 89.8526 5.40176 90.9628 7.3247L157.312 122.25L157.313 122.25C158.423 124.173 159.008 126.355 159.009 128.576C159.009 130.797 158.424 132.979 157.314 134.903C156.203 136.826 154.606 138.424 152.682 139.534C150.759 140.645 148.577 141.229 146.356 141.229H13.6529C11.4317 141.229 9.24967 140.645 7.32613 139.534L6.82615 140.4L7.32613 139.534C5.40258 138.424 3.80528 136.826 2.6948 134.903C1.58432 132.979 0.999795 130.797 1 128.576C1.00021 126.355 1.58513 124.173 2.69597 122.25Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.873 42.2699H79.1421C74.8805 42.2699 71.4258 45.7246 71.4258 49.9862V86.8686C71.4258 91.1302 74.8805 94.5849 79.1421 94.5849H80.873C85.1346 94.5849 88.5893 91.1302 88.5893 86.8686V49.9862C88.5893 45.7246 85.1346 42.2699 80.873 42.2699Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0075 123.836C84.7471 123.836 88.5893 119.994 88.5893 115.254C88.5893 110.515 84.7471 106.673 80.0075 106.673C75.268 106.673 71.4258 110.515 71.4258 115.254C71.4258 119.994 75.268 123.836 80.0075 123.836Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.fce0cd20c4820b140e62f2eb23ae1794.svg";
export { ForwardRef as ReactComponent };